import React, { useState } from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import { DataProvider, useData } from './context/DataContext';
import { Header } from './components/layout/Header';
import { Sidebar } from './components/layout/Sidebar';
import { MobileDrawer } from './components/layout/MobileDrawer';
import { LoginScreen } from './components/auth/LoginScreen';

// Tab Contents
import { ParticipationTab } from './components/participation/ParticipationTab';
import { PerformanceOverviewTab } from './components/overview/PerformanceOverviewTab';
import { CurriculumAnalysisTab } from './components/curriculum/CurriculumAnalysisTab';
import { ReportCardTab } from './components/report-cards/ReportCardTab';
import { QuestionPapersTab } from './components/question-papers/QuestionPapersTab';

// Overlay Modals
import { StudentReportCardModal } from './components/report-cards/StudentReportCardModal';
import { QuestionPaperModal } from './components/question-papers/QuestionPaperModal';
// import "./index.css";
const DashboardLayout = () => {
  const { user } = useAuth();
  const { activeTab } = useData();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  
  // Globally managed modal triggers
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [selectedPaperGrade, setSelectedPaperGrade] = useState(null);

  const handleOpenMenu = () => setIsMenuOpen(true);
  const handleCloseMenu = () => setIsMenuOpen(false);

  const handleViewReport = (student) => {
    setSelectedStudent(student);
  };

  const handleOpenQuestionPaper = (grade) => {
    setSelectedPaperGrade(grade);
  };

  const renderActiveTab = () => {
    switch (activeTab) {
      case 'participation':
        return <ParticipationTab onViewReport={handleViewReport} />;
      case 'overview':
        return <PerformanceOverviewTab onViewReport={handleViewReport} />;
      case 'curriculum':
        return (
          <CurriculumAnalysisTab
            onViewReport={handleViewReport}
            onOpenQuestionPaper={handleOpenQuestionPaper}
          />
        );
      case 'reports':
        return <ReportCardTab onOpenQuestionPaper={handleOpenQuestionPaper} />;
      case 'papers':
        return <QuestionPapersTab />;
      default:
        return <ParticipationTab onViewReport={handleViewReport} />;
    }
  };

  // Show login screen when not authenticated
  // if (!user) {
  //   return <LoginScreen />;
  // }

  return (
    <div className="h-full bg-gray-50 min-h-screen">
      {/* Fixed Header */}
      {/* <Header onMenuClick={handleOpenMenu} /> */}

      {/* Fixed Sidebar (Desktop) */}
      <Sidebar />

      {/* Sidebar Drawer (Mobile) */}
      <MobileDrawer isOpen={isMenuOpen} onClose={handleCloseMenu} />

      {/* Main Content Area */}
      <main className="app-main overflow-auto">
        {renderActiveTab()}
      </main>

      {/* Global Student Report card modal overlay */}
      {selectedStudent && (
        <StudentReportCardModal
          student={selectedStudent}
          onClose={() => setSelectedStudent(null)}
          onOpenQuestionPaper={handleOpenQuestionPaper}
        />
      )}

      {/* Global Question Paper viewer modal overlay */}
      {selectedPaperGrade !== null && (
        <QuestionPaperModal
          grade={selectedPaperGrade}
          onClose={() => setSelectedPaperGrade(null)}
        />
      )}
    </div>
  );
};

export default function SamagraDashboardApp() {
  return (
    <AuthProvider>
      <DataProvider>
        <DashboardLayout />
      </DataProvider>
    </AuthProvider>
  );
}
